const responsiveTextarea = {
    beforeMount: (el) => {

        el.style.height = el.setAttribute('style', 'height: ' + el.scrollHeight + 'px');
        el.classList.add('auto');
        el.setHeight = () => {
            el.style.height = 'auto';
            el.style.height = (el.scrollHeight) + 'px';
        }
        el.addEventListener('input', el.setHeight)
    },
    unmounted: el => {
        el.removeEventListener("input", el.setHeight);
    },
};

export default responsiveTextarea